import { Grid, Item, Label, Segment } from "semantic-ui-react";

import "modules/DealerOverviewDashboard/components/DmsSystem/components/Network/Network.scss";

import type { TFunction } from "i18next";

export type SendingDnsRecord = {
  Name: string;
  Priority: string;
  Valid: string;
  Value: string;
  record_type: string;
};

export const DnsRecord = ({ record, isDomainVerified, t }: { record: SendingDnsRecord; isDomainVerified: boolean; t: TFunction }) => (
  <Segment key={`${record.Name}-${record.Value}`} className={`dns-record-segment ${isDomainVerified ? "-verified" : "-invalid"}`}>
    <Item>
      <label>{t("v8_record_type", "Record type")}: </label> <span className="Segment">{record.record_type}</span> <br />
    </Item>
    {record.Name && (
      <Item>
        <label>{t("v8_name", "Name")}: </label> <span className="Segment">{record.Name}</span>
      </Item>
    )}
    <Item>
      <Grid container className="dns-record-grid">
        <Grid.Row columns={2}>
          <Grid.Column width={2} className="-no-padding-left">
            <label>{t("v8_value", "Value")}: </label>
          </Grid.Column>
          <Grid.Column width={14} className="-no-padding-right">
            <span className="Segment dns-record-value">{record.Value}</span>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Item>
    <Label corner="left" size="mini" icon={isDomainVerified ? "check" : "question circle outline"} color={isDomainVerified ? "green" : "grey"} />
  </Segment>
);
